module.exports = __webpack_public_path__ + "static/media/4 realistic feather wings eagle hawk .1280x1707.64e0e404.webp";